const coins = [
  50000, 20000, 10000, 5000, 2000, 1000, 500, 200, 100, 50, 20, 10, 5, 2, 1,
];

export default (amount, available) => {
  const unpacked = available
    .map((i, j) => new Array(i).fill(coins[j]))
    .flat()
    .sort((a, b) => b - a);
  const taken = [];
  const found = [];
  (function findCombination(remaining, path, arr, start) {
    const token = [...path.sort()].join('-');
    if (taken.includes(token)) {
      return;
    }
    taken.push(token);
    if (remaining <= 0) {
      found.push(path);
      return;
    }
    for (let i = start; i < arr.length; i += 1) {
      const r = remaining - arr[i];
      const ar = arr.filter((_, j) => i !== j);
      findCombination(r, [...path, arr[i]], ar, i);
    }
  })(amount, [], unpacked, 0);
  if (found.length === 0) {
    return null;
  }
  const results = found
    .map((path) => {
      const total = path.reduce((t, c) => t + c, 0);
      const used = coins.map((v) => path.filter((c) => c === v).length);
      return {
        n: path.length,
        used,
        total,
        isExact: amount === total,
      };
    })
    .sort((a, b) => a.n - b.n || a.total - b.total);
  const exactResult = results.find((arr) => arr.isExact);
  if (exactResult) {
    return exactResult.used;
  }
  return results[0].used;
};
